
export default function Header() {
  return (
    <header className="w-full bg-white/80 backdrop-blur-sm shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/1df1c944acacf8d1b1994470ac18dfcd/34f0989ae91e99f0a60830cf0ae1d9c8.png" 
              alt="Cookie Clicker Logo" 
              className="w-12 h-12 object-contain"
            />
            <h1 className="text-2xl font-bold text-amber-800">Cookie Clicker</h1>
          </div>
          <nav className="flex items-center gap-6">
            <a href="#game" className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors whitespace-nowrap cursor-pointer">Play Game</a>
            <a href="#leaderboard" className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors whitespace-nowrap cursor-pointer">Leaderboard</a>
            <a href="#about" className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors whitespace-nowrap cursor-pointer">About</a>
          </nav>
        </div>
      </div>
    </header>
  );
}
